<template>
  <div class="Step4Container">
    <div>
      <!-- Upper Area -->
      <transition name="slide-left" mode="out-in">
        <div class="SelectTabletType">
          <ButtonGroupHorizontal class="btnLayout">
            <!-- 位牌の種類 -->
            <div
              class="tabletTypes flex center"
              :class="{
                tableMindAlte: isMindAlte,
              }"
            >
              <template v-for="item in tabletTypeOptions">
                <VisualButtonHorizontal
                  v-if="item.isMindAlte === isMindAlte"
                  :key="item.value"
                  :text="item.label"
                  :isActive="item.value === form.type"
                  class="box grow"
                  @click="onClickTypeSelection(item.value)"
                />
              </template>
            </div>

            <i
              id="arrow-icon"
              class="el-icon-caret-right SelectTabletType-CaretRightIcon arrow-gray"
            />

            <!-- 霊の数（俗名位牌選択時） -->
            <ButtonGroupHorizontal
              v-if="form && form.type === '俗名位牌'"
              :variant="{ align: 'center' }"
              style="margin-right:14rem;"
            >
              <VisualButtonHorizontal
                :text="tabletNameCountOptions[0].label"
                :isActive="tabletNameCountOptions[0].value === form.nameCount"
                @click="
                  onClickNameCountSelection(tabletNameCountOptions[0].value)
                "
              />
            </ButtonGroupHorizontal>

            <!-- 通常位牌 -->
            <ButtonGroupHorizontal
              v-if="form && form.type === '通常位牌' || form.type === 'マインドアルテ'"
              :variant="{ align: 'center' }"
            >
              <VisualButtonHorizontal
                v-for="item in tabletNameCountOptions"
                :key="item.label"
                :text="item.label"
                :isActive="item.value === form.nameCount"
                @click="onClickNameCountSelection(item.value)"
              />
            </ButtonGroupHorizontal>
          </ButtonGroupHorizontal>
        </div>
      </transition>

      <!-- Bottom Area -->
      <transition name="slide-left" mode="out-in">
        <!-- Layout Selection Area -->
        <div class="selectLayout" v-if="isEdited">
          <div class="LayoutSelection">
            <el-card
              :body-style="{ padding: '0px' }"
              v-for="item in layouts"
              :key="item.id"
              shadow="never"
              class="Card"
              :class="{
                isSelected: form.layout && item.id == form.layout.id
              }"
              @click="onClickCard(item.id)"
            >
              <div @click="onClickCard(item)">
                <img
                  :src="item.imageUrl"
                  :alt="item.name"
                  class="card__image"
                />
                <div style="padding: 14px;">
                  <span class="title">{{ item.name }}</span>
                </div>
              </div>
            </el-card>
          </div>
        </div>
      </transition>
    </div>

    <OrderFormFooter
      message="位牌の種類とレイアウトを選択してください"
      :canClickGoBack="true"
      @onClickGoBack="onClickGoBack"
      :canClickGoForward="isValidInput"
      @onClickGoForward="onClickGoForward"
    />
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

// Data Handler
import OrderUsecase from "@/usecases/order.usecase";
import EntityFactory from "@/entities/entity.factory";

// Components
import OrderFormFooter from "@/components/OrderFormFooter";
import VisualButtonHorizontal from "@/components/VisualButtonHorizontal";
import ButtonGroupHorizontal from "@/components/ButtonGroupHorizontal";

import { apiErrorHandler } from "@/services/apiErrorHandler";

const orderOption = EntityFactory.create("orderOption");

export default {
  components: {
    OrderFormFooter,
    VisualButtonHorizontal,
    ButtonGroupHorizontal,
  },
  async created () {},
  mounted () {
    // update step
    this.$store.commit("orderForm/setCurrentStep", 2);
    // this.$store.commit("orderForm/init");

    // 通常位牌からマインドアルテ、もしくはその逆に変更した場合に位牌プレビューが崩れる現象が発生するため form.type の整合性を確認する
    this.validateFormType();
  },
  data () {
    return {
      orderUsecase: new OrderUsecase(),
      tablets: [],
      dialogVisible: false,

      tabletTypeOptions: orderOption.tabletTypes,
      tabletNameCountOptions: orderOption.nameCounts,
      selectType: "",
    };
  },
  computed: {
    ...mapState({
      layouts: state => state.master.layouts,
    }),
    ...mapGetters({
      order: "orderForm/order",
      previousStep: "orderForm/previousStep",
      nextStep: "orderForm/nextStep",
      isMindAlte: "orderForm/isMindAlte",
    }),
    form: {
      get () {
        return this.$store.state.orderForm.orderTypeInput;
      },
      async set (value) {
        this.$store.commit("orderForm/setOrderTypeInput", { ...value });
      },
    },
    isValidInput: function () {
      return this._isValidInput();
    },
    isEdited () {
      if (
        this.form.type &&
        this.form.nameCount
      ) {
        this.updateLayouts();
        return true;
      }
      return false;
    },
  },
  methods: {
    validateFormType () {
      if (
        (this.isMindAlte && this.form.type !== "マインドアルテ") ||
        (!this.isMindAlte && this.form.type === "マインドアルテ")
      ) {
        // レイアウトのリセット
        this.form.type = "";
        this.updateLayouts();

        // 書体のリセット
        this.$store.commit("orderForm/setTypographyInput", {});
      }
    },

    onClickGoForward () {
      const { $router } = this;
      const { form } = this;
      const params = { ...form };
      this.$store.commit("orderForm/setOrderTypeInput", params);
      $router.push(this.nextStep);
    },
    onClickGoBack () {
      const { $router } = this;
      $router.push(this.previousStep);
    },

    onClickTypeSelection (type) {
      this.form = {
        ...this.form,
        type,
        // nameCount should be initialized
        nameCount: null,
        // layout type should be initialized
        layout: {},
      };
      this.updateLayouts();

      // FIXME:
      // - unneeded flag
      //   so, should be removed
      this.selectType = type;
    },
    onClickNameCountSelection (nameCount) {
      this.form = { ...this.form, nameCount };

      const columns = [...Array(nameCount)].map(() => {
        return {
          buddhistName: [],
          underCharacters: [],
          ageAtDeath: [],
          title: "",
          secularName: [],
          dateOfDeathYear: [],
          dateOfDeathMonth: [],
          dateOfDeathDay: [],
          secularNamePrefix: [],
        };
      });

      this.$store.commit("orderForm/updateDetail", { columns });
      this.updateLayouts();
    },

    async updateLayouts () {
      const { type, nameCount } = this.form;

      if (type && nameCount) {
        const query = {
          type,
          nameCount,
        };

        try {
          const layouts = await this.orderUsecase.getLayouts(query);

          this.$store.commit("master/set", { key: "layouts", value: layouts });
        } catch (err) {
          apiErrorHandler(this, err);
        }
      }
    },

    onClickCard (layout) {
      let layoutId = layout.id;

      const IS_UNSELECT_ACTION =
        this.form.layout && this.form.layout.id === layoutId;
      if (IS_UNSELECT_ACTION) {
        // if this is "un-select" action, save the null as category id
        this.form = { ...this.form, ...{ layout: {} } };
        return;
      }
      this.form = { ...this.form, ...{ layout } };
    },
    onClickSubmit () {
      this.dialogVisible = true;
    },
    onClickConfirm () {
      this.dialogVisible = false;
      this.$router.push("/home");
    },
    handleClose (done) {
      this.$confirm("Are you sure to close this dialog?")
        .then(() => {
          done();
        })
        .catch(() => {});
    },
    _isValidInput () {
      return !!this.layouts.filter(
        el => this.form.layout && el.id === this.form.layout.id
      ).length;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

$--row-height: 370px;

.Step4Container {
  margin-bottom: 9%;
}
.SelectTabletType-Type {
  margin-right: 10px;
}

.SelectTabletType-CaretRightIcon {
  font-size: 35px;
}

.selectLayout {
  margin: 20px 20px 0 20%;
}
.LayoutSelection {
  display: grid;
  grid-gap: 10px;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: $--row-height;
  text-align: center;
  width: 100px;
  margin-bottom: 5rem;
}

.Card {
  cursor: pointer;
  width: 29vw;
  height: 100%;
}

.card__image {
  height: calc(#{$--row-height} - 45px);
  margin: 0;
  text-align: center;
}

.title {
  font-weight: bold;
}

.description {
  color: gray;
}

.isSelected {
  border: 2.5px solid $--color-primary;
}

.btnLayout {
  margin: 3% 20%;
}

.tabletTypes {
  display: inline-flex;

  &.tableMindAlte {
    width: 100%;
    max-width: 26vw;
  }
}
</style>
